const USER_INFO_CACHE_DURATION = 120;
const USER_INFO_CACHE_KEY = 'USER_INFO_CACHE_KEY';
const USER_INFO_STATE = {
    LOADING:0,
    LOGGED_IN:1,
    LOGGED_OUT:2
}
Object.freeze(USER_INFO_STATE);
export {USER_INFO_STATE, USER_INFO_CACHE_DURATION, USER_INFO_CACHE_KEY}